<template>
  <div class="py-2 px-2 md:px-0 md:py-12 mx-auto w-full md:max-w-xl flex flex-col items-center">
    <LogoDefault class="flex-none md:max-w-md" />
    <div class="flex flex-row mt-6 px-6 md:pl-12 md:pr-4 py-2 w-full items-center shadow rounded-lg bg-white dark:bg-slate-900">
      <LanguageSwitcher class="flex-1 rounded-md" />
      <Divider
        v-if="false"
        class="border-r"
        layout="vertical"
        type="solid" />
      <div class="flex-none text-gray-400 hover:text-gray-500 dark:text-gray-600 dark:hover:text-gray-500" v-if="false">
        <BrightnessDark
          v-if="newStyle === 'dark'"
          :title="`Modus: Dunkel`"
          class="titrop-focus"
          @click="nextStyle()" />
        <BrightnessLight
          v-else-if="newStyle === 'light'"
          :title="`Modus: Hell`"
          class="titrop-focus"
          @click="nextStyle()" />
        <BrightnessAuto
          v-else-if="newStyle === 'auto'"
          :title="`Modus: Automatisch`"
          class="titrop-focus"
          @click="nextStyle()" />
      </div>
    </div>
    <div class="w-full px-1 md:px-12 py-3 md:py-8 md:pt-4 mt-2 shadow md:rounded-lg dark:shadow-gray-400 bg-white dark:bg-slate-900">
      <slot v-if="$slots.default" />
      <RouterView
        v-else
        :key="$route.fullPath" />
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { RouterView } from 'vue-router'
  import LogoDefault from '@/components/layout/LogoDefault.vue'
  import LanguageSwitcher from '@/elements/LanguageSwitcher.vue'
  import BrightnessLight from 'vue-material-design-icons/Brightness5.vue'
  import BrightnessDark from 'vue-material-design-icons/Brightness3.vue'
  import BrightnessAuto from 'vue-material-design-icons/BrightnessAuto.vue'
  import { useColorMode, useCycleList } from '@vueuse/core'
  import { watch } from 'vue'

  const mode = useColorMode({ initialValue: 'light', storageKey: null })
  const { next: nextStyle, state: newStyle } = useCycleList<'light' | 'dark' | 'auto'>(['auto', 'dark', 'light'], { initialValue: mode })
  watch(newStyle, (m) => (mode.value = m))
</script>
